import template from "./settings-custom-fields.html";
import { snakeCase } from "lodash";

const SettingsCustomFieldsComponent = {
  template: template,
  controller: class SettingsCustomFieldsController {
    /* @ngInject */
    constructor($rootScope, $filter, OrganizationService, Notification) {
      this.$rootScope = $rootScope;
      this.$filter = $filter;
      this.OrganizationService = OrganizationService;
      this.NotificationService = Notification;
    }

    $onInit() {
      this.organization = this.$rootScope.organization;
      this.customFields = this.organization.settings.customFields;
    }

    async save() {
      if (this.form.$invalid || this.checkDuplicateKeys()) return;

      try {
        this.loading = true;
        this.organization = await this.OrganizationService.createCustomFields(
          this.customFields
        );
        this.onSuccess();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.$rootScope.$applyAsync();
      }
    }

    async deleteCustomField(index) {
      const customField = this.customFields[index];
      this.customFields.splice(index, 1);

      if (!customField._id) {
        return;
      }

      try {
        this.loading = true;
        this.organization = await this.OrganizationService.deleteCustomField(
          customField._id
        );
        this.onSuccess();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        this.$rootScope.$applyAsync();
      }
    }

    onSuccess() {
      this.customFields = this.organization.settings.customFields;
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")(
          "notificationService.message.customFields"
        ),
      });
      this.form.$setPristine();
    }

    checkDuplicateKeys() {
      const duplicateFields = this.customFields
        .map((customField) => snakeCase(customField.key))
        .filter(
          (key, index, customFieldKeys) =>
            customFieldKeys.indexOf(key) !== index
        );
      if (duplicateFields.length) {
        this.NotificationService.error({
          title: this.$filter("trans")(
            "notificationService.title.duplicateCustomField"
          ),
          message: `${this.$filter("trans")(
            "notificationService.message.duplicateCustomField"
          )}: ${duplicateFields.join(", ")}`,
        });
      }
      return !!duplicateFields.length;
    }

    removeIfEmpty(index) {
      const customField = this.customFields[index];

      if (!customField.key && !customField.value)
        this.customFields.splice(index, 1);
    }
  },
};

export default SettingsCustomFieldsComponent;
